import {
  IGenericAuthResponse,
} from "../../../user";
import axios, {AxiosResponse} from "axios";
import {APIS} from "../../../../static/apis";

export async function deleteBiometricDeviceService (deviceUuid: string): Promise<AxiosResponse<IGenericAuthResponse<object>>> {
  return axios.delete(
    APIS.BASE_AUTH_MS_URL + APIS.REMOVE_BIOMETRIC_DEVICE,
    {
      params: {
        deviceUuid
      }
    },
  )
}